module.exports = __webpack_public_path__ + "img/sm_tiktok.46f611d0.png";